var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgJpg = function SvgJpg(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DB8F0",
    fillRule: "evenodd",
    d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0v4a2 2 0 0 0 2 2h4z",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 2,
    y: 13,
    fill: "#F7F8FA",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DB8F0",
    d: "M5.875 15.053h.975v2.692a1.2 1.2 0 0 1-.19.662 1.25 1.25 0 0 1-.52.437Q5.81 19 5.378 19a1.8 1.8 0 0 1-.697-.127 1.1 1.1 0 0 1-.498-.396q-.184-.267-.182-.686h.985q.006.15.06.256.057.105.154.158a.5.5 0 0 0 .234.054.47.47 0 0 0 .24-.058.37.37 0 0 0 .148-.172.7.7 0 0 0 .054-.284zM8.034 18.947v-3.894h1.69q.46 0 .794.171.336.169.518.474.182.302.182.703 0 .403-.186.706-.184.3-.526.465-.341.166-.811.166H8.652v-.742h.86a.84.84 0 0 0 .373-.074.53.53 0 0 0 .23-.207.6.6 0 0 0 .078-.314.6.6 0 0 0-.078-.312.5.5 0 0 0-.23-.205.9.9 0 0 0-.374-.072h-.488v3.135zM14.955 16.325a.67.67 0 0 0-.262-.369.7.7 0 0 0-.22-.097 1 1 0 0 0-.272-.034.95.95 0 0 0-.516.137.9.9 0 0 0-.333.4 1.5 1.5 0 0 0-.118.632q0 .375.114.64.114.263.33.402a.95.95 0 0 0 .523.139q.272 0 .46-.084a.64.64 0 0 0 .288-.241.68.68 0 0 0 .098-.367l.183.02h-.995v-.686H16v.516q0 .522-.234.895-.232.374-.64.572-.405.2-.933.2-.585 0-1.03-.241a1.7 1.7 0 0 1-.69-.689q-.248-.449-.248-1.064 0-.48.15-.85.15-.372.417-.631.27-.259.624-.392.355-.133.765-.133.356 0 .662.097t.543.274q.239.177.386.42t.184.534z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJpg);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;